(function(angular) {
  'use strict';

  var app = angular.module('asSupplyMgr');

  app.service('itemsApi', [
    '$http',
    '$q',
    function($http, $q) {
      this.getList = (sort, search, page, statusFilter, sourceFilter, inventoryTypesFilter) => {
        let url = '/supply/inventory/items/list' +
                  getReportUrl(sort, search, {'status': statusFilter, 'sources': sourceFilter, 'inventoryTypes': inventoryTypesFilter},
                      page);
        url += window.Application.getQueryString();
        return $q((resolve, reject) => {
          $http.get(url).then(
            res => {
              console.log(res);
              resolve(res.data);
            },
            res => {
              console.log(res);
              reject({ code: res.data.errorCode, message: res.data.message });
            }
          );
        });
      };

      this.changeState = (id, state) => {
        const url = '/supply/inventory/items/state';

        return $q((resolve, reject) => {
          $http.post(url, { id, state }).then(
            res => {
              resolve(res);
            },
            res => {
              console.log(res);
              reject(res);
            }
          );
        });
      };


        this.getIabCategories = function(extended,withSubCats,showId) {
            var url = '/demandmgr/options/iab';
            if (extended){
                url += "?extended=true";
            }
            if (withSubCats){
                url += extended ? '&' : '?';
                url += "withSubCats=true";
            }

            if (showId){
                url += extended || withSubCats ? '&' : '?';
                url += "showId=true";
            }

            return $q(function(resolve, reject) {
                $http.get(url).then(
                    // success
                    function(res) {
                        resolve(res.data);
                    },
                    // error
                    function(res) {
                        reject();
                    }
                );
            });
        };

        this.getIabTcfStrictLevels = function() {
            return $q(function(resolve, reject) {
                var url = '/demandmgr/options/iab-tcf-strict-levels';
                $http.get(url).then(
                    // success
                    function(res) { resolve(res.data); },
                    // error
                    function(res) { reject(); }
                );
            });
        };

      this.getTypes = () => {
        const url = '/supply/inventory/items/types';

        return $q((resolve, reject) => {
          $http.get(url).then(
            res => {
              resolve(res.data.types);
            },
            res => {
              reject(res);
            }
          );
        });
      };

      this.getSources = () => {
        const url = '/supply/inventory/items/sources';

        return $q((resolve, reject) => {
          $http.get(url).then(
            res => {
              resolve(res.data.sources);
            },
            res => {
              reject(res);
            }
          );
        });
      };

      this.getDeals = () => {
        const url = '/supply/inventory/items/deals';

        return $q((resolve, reject) => {
          $http.get(url).then(
            res => {
              resolve(res.data.deals);
            },
            res => {
              reject(res);
            }
          );
        });
      };

      this.getDevices = () => {
        const url = '/supply/inventory/items/devices';

        return $q((resolve, reject) => {
          $http.get(url).then(
            res => {
              resolve(res.data.devices);
            },
            res => {
              reject(res);
            }
          );
        });
      };

      this.getCreatives = () => {
        const url = '/supply/inventory/items/creatives';

        return $q((resolve, reject) => {
          $http.get(url).then(
            res => {
              resolve(res.data.creatives);
            },
            res => {
              reject(res);
            }
          );
        });
      };


        this.duplicate = id => {
            const url = '/supply/inventory/items/duplicate';

            return $q((resolve, reject) => {
                    $http.post(url, {id: id}).then(
                    res => {
                      resolve(res);
                    },
                     res => {
                      console.log(res);
                      reject(res);
                      }
                    );
            });
        };

        this.info = id => {
            const url = `/supply/inventory/items/info?id=${id}`;

            return $q((resolve, reject) => {
                    $http.get(url).then(
                    res => {
                    resolve(res);
        },
            res => {
                console.log(res);
                reject(res);
            }
        );
        });
        };



      this.delete = id => {
        const url = `/supply/inventory/items?id=${id}`;

        return $q((resolve, reject) => {
          $http.delete(url).then(
            res => {
              resolve(res);
            },
            res => {
              reject(res);
            }
          );
        });
      };



      this.save = item => {
        let url = '/supply/inventory/items/save';

        return $q((resolve, reject) => {
          $http.post(url, item).then(
            res => {
              if (res.data.status === 'success') {
                  resolve();
              } else {
                  reject(res.data);
              }
        },
            res => {
              reject(res);
            }
          );
        });
      };

      this.read = id => {
        let url = `/supply/inventory/items/read?id=${id}`;

        return $q((resolve, reject) => {
          $http.get(url).then(
            res => {
              resolve(res.data);
            },
            res => {
              reject();
            }
          );
        });
      };
    },
  ]);
})(window.angular);
